export enum OpentokErrors {
  USER_MEDIA_ACCESS_DENIED = 'OT_USER_MEDIA_ACCESS_DENIED',
  HARDWARE_UNAVAILABLE = 'OT_HARDWARE_UNAVAILABLE'
}
